/**
 * Favorites - Página de listagem de artigos favoritos
 *
 * TRANSFORMER PATTERN:
 * Esta página agora usa ArticleListPageTemplate com filtro de favoritos.
 * - baseFilter: { isFavorite: true } (apenas artigos favoritos)
 * - pageTitle: "Favoritos"
 * - pageConfig: { showScraping: false, showBackgroundScraping: false }
 *
 * ANTES: 180 linhas de código (implementação própria incompleta)
 * DEPOIS: 10 linhas de código
 * BENEFÍCIO: Agora tem TODAS as funcionalidades (bulk actions, filtros, etc)!
 */
import React from 'react';
import ArticleListPageTemplate from '../components/templates/ArticleListPageTemplate/ArticleListPageTemplate';

const Favorites = () => {
  return (
    <ArticleListPageTemplate
      pageTitle="Favoritos"
      baseFilter={{ isFavorite: true }}
      pageConfig={{
        showScraping: false,
        showBackgroundScraping: false
      }}
    />
  );
};

export default Favorites;
